import { Stack, Typography } from "@mui/material";

import { EVOTRUX_NAVY } from "constants/index";

interface Props {
  status: ShipmentStatusValue;
}

// Placeholder copy — pending final product wording.
const STATUS_NOTICE_COPY: Partial<Record<ShipmentStatusValue, string>> = {
  ACTIVE: "This shipment is in the quoting process — more info coming soon!",
  EXPIRED: "This shipment posting has expired.",
  CANCELLED: "This shipment has been cancelled.",
  BOOKING_CANCELLED: "This shipment's booking was cancelled.",
};

export function PublicShipmentStatusNotice(props: Props) {
  const { status } = props;
  const message = STATUS_NOTICE_COPY[status];

  if (!message) {
    return null;
  }

  return (
    <Stack
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{ py: "3rem", px: "1.5rem" }}
    >
      <Typography variant="h6" textAlign="center" sx={{ color: EVOTRUX_NAVY }}>
        {message}
      </Typography>
    </Stack>
  );
}
